import React, { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import Select, { SingleValue } from "react-select";
import {
  activeList,
  gradeOne,
  gradePercentage,
  gradePoints,
  marksFrom,
  marksUpto,
  sections,
  statusOption,
} from "../../../../core/common/selectoption/selectoption";
import Table from "../../../../core/common/dataTable/index";
import { gradetable } from "../../../../core/data/json/grade";
import { TableData } from "../../../../core/data/interface";
import CommonSelect, { Option } from "../../../../core/common/commonSelect";
import PredefinedDateRanges from "../../../../core/common/datePicker";
import { all_routes } from "../../../router/all_routes";
import TooltipOption from "../../../../core/common/tooltipOption";
import { _get, _post } from "../../../Utils/Helper";
import { Button, Input } from "antd";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { RootState } from "../../../../redux/reducers";
import moment from "moment";
const _form ={
    school_id:"",
  section:"",
  start_time:"",
  end_time:"",
  activities:"",
  status:"Active",
}
const ClassTaming = () => {
  const routes = all_routes;
  const data = gradetable;
  const [class_taming, setClassTaming] = useState([])
  const [form, setForm] = useState(_form);

   const { user, classes } = useSelector((state: RootState) => state.auth);
//    const { user, classes } = useSelector((state: any) => state.auth);
  const handleChanges = (e: React.ChangeEvent<HTMLInputElement>) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };
  const sections = classes.length
  ? Array.from(new Set(classes.map((cls) => cls.section)))
  : [];
  const mapped_section = sections?.map((i: any) => ({
    label: i,
    value: i,
  }));
  const getClassTaming = useCallback(()=>{
    _get(
      "get_class_timing?query_type=select",
      (res) => {
        console.log(res);
        if (res.data && res.data.length) {
            setClassTaming(res.data);
        }
      },
      (err) => {
        toast.error("Error occured")
        console.error("Error: ",err);
      }
    );
  },[])

  useEffect(() => {
    getClassTaming()
  }, [])
const handleSubmit = () => {
    if ( !form.section || !form.start_time || !form.end_time || !form.activities) {
      toast.error("Please fill in all required fields.");
      return;
    }
    console.log(form);
    const formattedStartTime = moment(form.start_time, "HH:mm").format("hh:mm A");
    const formattedEndTime = moment(form.end_time, "HH:mm").format("hh:mm A");
    
    const payload = {
      ...form,
      start_time: formattedStartTime,
      end_time: formattedEndTime,
      school_id: user.school_id,
    };
  
    _post("class_timing", payload, 
      (res) => {
        if (res.success) {
          toast.success("Submitted successfully!");
          setForm(_form);
          getClassTaming()
          console.log(_form); 
        }
        console.log("Response:", res);
      }, 
      (err) => {
        toast.error("Error: Submission failed.");
        console.error("Error:", err);
      }
    );
  };
  
  const dropdownMenuRef = useRef<HTMLDivElement | null>(null);
  const handleApplyClick = () => {
    if (dropdownMenuRef.current) {
      handleSubmit()
      dropdownMenuRef.current.classList.remove("show");
    }
  };
  const columns = [
    {
      title: "Section",
      dataIndex: "section",
      render: (text: string) => <span>{text}</span>,
    },
    {
      title: "Start Time",
      dataIndex: "start_time",
      render: (text: string) => <span>{text}</span>,  
    },
    {
      title: "End Time",
      dataIndex: "end_time",
      render: (text: string) => <span>{text}</span>,  
    },
    {
      title: "Activities",
      dataIndex: "activities",
      render: (text: string) => <span>{text}</span>,  
    },
  ];
  
  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <div className="my-auto mb-2">
              <h3 className="page-title mb-1">Class Duration</h3>
              {/* <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to={routes.adminDashboard}>Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="#">Academic </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Class Duration
                  </li>
                </ol>
              </nav> */}
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <TooltipOption />
              <div className="mb-2">
                <Link
                  to="#"
                  className="btn btn-primary"
                  data-bs-toggle="modal"
                  data-bs-target="#add_grade"
                >
                  <i className="ti ti-square-rounded-plus-filled me-2" />
               Class Duration
                </Link>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          {/* Guardians List */}
          <div className="card">
            {/* {JSON.stringify(form)} */}
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Class Duration</h4>
              <div className="d-flex align-items-center flex-wrap">
               
              </div>
            </div>
            <div className="card-body p-0 py-3">
                {/* {JSON.stringify(class_taming)} */}
              {/* Guardians List */}
              <Table columns={columns} dataSource={class_taming} Selection={false} />

              {/* /Guardians List */}
            </div>
          </div>
          {/* /Guardians List */}
        </div>
      </div>
      <>
        <div className="d-flex align-items-center">
          <div className="dropdown">
            <Link
              to="#"
              className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <i className="ti ti-dots-vertical fs-14" />
            </Link>
            <ul className="dropdown-menu dropdown-menu-right p-3">
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#edit_grade"
                >
                  <i className="ti ti-edit-circle me-2" />
                  Edit 1
                </Link>
              </li>
              <li>
                <Link
                  className="dropdown-item rounded-1"
                  to="#"
                  data-bs-toggle="modal"
                  data-bs-target="#delete-modal"
                >
                  <i className="ti ti-trash-x me-2" />
                  Delete 1
                </Link>
              </li>
            </ul>
          </div>
        </div>
        {/*Class Duration */}
        <div className="modal fade" id="add_grade">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Class Duration</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Section</label>
                        {/* <input type="text" className="form-control"  name="section"
                          onChange={handleChanges}
                          value={form.section} /> */}
                          <CommonSelect
                                      className="select"
                                      options={mapped_section}
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setForm((prev) => ({
                                          ...prev,
                                          section: newValue
                                            ? newValue.value
                                            : "",
                                        }))
                                      }
                                      defaultValue={{
                                        label: form.section,
                                        value: form.section,
                                      }}
                                    />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Start Time</label>
                        <input type="time" className="form-control"  name="start_time"
                          onChange={handleChanges}
                          value={form.start_time}/>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">End Time</label>
                        <input type="time" className="form-control"  name="end_time"
                          onChange={handleChanges}
                          value={form.end_time}/>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">Activities</label>
                        <input type="text" className="form-control"  name="activities"
                          onChange={handleChanges}
                          value={form.activities}/>
                      </div>
                     
                      {/* <div className="mb-3">
                        <label className="form-label">Activities</label>
                        <CommonSelect 

                        defaultValue={{label:form.status, value:form.status}}
                        handleChange={(e:any)=>{
                          setForm((x)=>({...x, status:e.value}))
                        }}
                        className="select" options={activeList} />
                      </div> */}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Link
                    to="#"
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Link>
                  <Link
                    to="#"
                    className="btn btn-primary"
                    onClick={handleSubmit}
                    // data-bs-dismiss="modal"

                  >
                 Class Duration
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/*Class Taming */}
        {/* Edit Grade */}
        <div className="modal fade" id="edit_grade">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Edit Grade</h4>
                <button
                  type="button"
                  className="btn-close custom-btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <i className="ti ti-x" />
                </button>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="modal-body">
                  <div className="row">
                    <div className="col-md-12">
                      <div className="mb-3">
                        <label className="form-label">Section</label>
                        {/* <Input
                          type="text"
                          className="form-control"
                          placeholder="Enter Section"
                          name="Section"
                          onChange={handleChanges}
                          value={form.section}
                        /> */}
                        <CommonSelect
                                      className="select"
                                      options={mapped_section}
                                      handleChange={(
                                        newValue: SingleValue<Option>
                                      ) =>
                                        setForm((prev) => ({
                                          ...prev,
                                          section: newValue
                                            ? newValue.value
                                            : "",
                                        }))
                                      }
                                      defaultValue={{
                                        label: form.section,
                                        value: form.section,
                                      }}
                                    />

                      </div>
                      <div className="mb-3">
                        <label className="form-label">Start Time</label>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Enter Grade"
                          name="grade"
                          onChange={handleChanges}
                          value={form.start_time}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">End Time</label>
                        <Input
                          type="text"
                          className="form-control"
                          placeholder="Enter Grade"
                          name="end_time"
                          onChange={handleChanges}
                          value={form.end_time}
                        />
                      </div>
                      
                      <div className="mb-3">
                        <label className="form-label">Activitis</label>
                        <Input
                          className="text"
                          name="remark"
                          value={form.activities}
                          placeholder="Enter Remark"
                          onChange={handleChanges}
                        />
                      </div>
                    </div>
                    <div className="mb-3">
                        <label className="form-label">Status</label>
                        <CommonSelect
                        className="select"
                          placeholder="Select Status"
                          options={activeList}
                          defaultValue={{label:form.status, value:form.status}}
                          handleChange={(e:any)=>{
                            setForm((x)=>({...x, status:e.value}))
                          }}
                        />
                      </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <Button
                    className="btn btn-light me-2"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSubmit}
                    className="btn btn-primary"
                    // data-bs-dismiss="modal"
                  >
                    Save Changes
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Edit Grade */}
        {/* Delete Modal */}
        <div className="modal fade" id="delete-modal">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <form>
                <div className="modal-body text-center">
                  <span className="delete-icon">
                    <i className="ti ti-trash-x" />
                  </span>
                  <h4>Confirm Deletion</h4>
                  <p>
                    You want to delete all the marked items, this cant be undone
                    once you delete.
                  </p>
                  <div className="d-flex justify-content-center">
                    <Link
                      to="#"
                      className="btn btn-light me-3"
                      data-bs-dismiss="modal"
                    >
                      Cancel
                    </Link>
                    <Button
                      onClick={()=>handleSubmit()}
                      className="btn btn-danger"
                      data-bs-dismiss="modal"
                    >
                      Yes, Delete
                    </Button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* /Delete Modal */}
      </>
    </div>
  );
};

export default ClassTaming;
